export const ONBOARDING_START_DATE_BUFFER_DAYS = 7;
